import { all } from "redux-saga/effects";
import clients from "./redux/clients/saga";
export default function* rootSaga() {
  return yield all([
    clients,
    // sagas2,
    // sagas3
  ]);
}
